export const GET_RELEASE_NOTES = "GET_RELEASE_NOTES";
export const SET_RELEASE_NOTES = "SET_RELEASE_NOTES";
